/** `/client` — projects shared with the signed-in user as client or member (moat plan §5.2). */
import { createFileRoute, Link } from '@tanstack/react-router'
import { ChevronRight } from 'lucide-react'
import { ClientShell } from '#/components/studio/client-progress'
import { useClientPlans } from '#/lib/api-studio'
import { fmtRelative } from '#/lib/format'
import { m } from '#/paraglide/messages'

export const Route = createFileRoute('/client/')({
  head: () => ({ meta: [{ title: m.st_cl_plans_title() }] }),
  component: ClientPlansPage,
})

const DEFAULT_ACCENT = '#2757e6'

function ClientPlansPage() {
  const { data, isLoading } = useClientPlans()
  const plans = data?.plans ?? []
  const brandColor = plans.find((p) => p.branding?.color && /^#[0-9a-fA-F]{6}$/.test(p.branding.color))?.branding?.color ?? DEFAULT_ACCENT
  const brandName = plans.find((p) => p.branding?.name)?.branding?.name
  const brandLogo = plans.find((p) => p.branding?.logoUrl)?.branding?.logoUrl

  return (
    <ClientShell brand={{ name: brandName, logoUrl: brandLogo, color: brandColor }} title={m.st_cl_plans_title()}>
      <h1 className="font-heading text-2xl font-semibold">{m.st_cl_plans_title()}</h1>
      <p className="mt-1 text-sm text-slate-500">{m.st_cl_plans_desc()}</p>
      {isLoading ? (
        <p className="mt-6 text-sm text-slate-500">{m.st_loading()}</p>
      ) : !plans.length ? (
        <p className="mt-6 rounded-2xl border border-dashed border-slate-300 bg-white p-8 text-center text-sm text-slate-500">{m.st_cl_plans_empty()}</p>
      ) : (
        <ul className="mt-5 space-y-3">
          {plans.map((p) => (
            <li key={p.id}>
              <Link to="/client/$planId" params={{ planId: p.id }} className="flex items-center justify-between gap-3 rounded-2xl border border-slate-200 bg-white p-4 transition-colors hover:border-slate-400">
                <div className="min-w-0">
                  <div className="truncate font-medium">{p.title}</div>
                  <div className="truncate text-xs text-slate-500">
                    {p.workspaceName} · {m.st_cl_updated({ when: fmtRelative(p.updatedAt) })}
                  </div>
                </div>
                <span className="inline-flex shrink-0 items-center gap-1 text-sm" style={{ color: brandColor }}>
                  {m.st_cl_open()} <ChevronRight className="size-4" />
                </span>
              </Link>
            </li>
          ))}
        </ul>
      )}
    </ClientShell>
  )
}
